// extracted by mini-css-extract-plugin
export default {"root":"style_root__6i8xu","temp":"style_temp__B9x2I","dealingImage":"style_dealingImage__nugDu"};